import { apiSlice } from "../initalState"; // Ensure this exports a properly configured createApi instance

const apiWithTag = apiSlice.enhanceEndpoints({
  addTagTypes: ["send-otp", "check-role"],
});

export const authApiSlice = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: "/qiktrack/login",
        method: "POST",
        body: credentials,
      }),
    }),

    admin_login: builder.mutation({
      query: (credentials) => ({
        url: "/qiktrack/admin-login",
        method: "POST",
        body: credentials,
      }),
    }),
    sendOtp: builder.mutation({
      query: (credentials) => ({
        url: "/qiktrack/otp",
        method: "POST",
        body: credentials,
      }),
    }),

     resetPassword: builder.mutation({
      query: (credentials) => ({
        url: "/qiktrack/reset-password",
        method: "POST",
        body: credentials,
      }),
    }),
    register: builder.mutation({
      query: (payload) => ({
        url: '/qiktrack/company',
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
  }),
  overrideExisting: true,
});

export const { useLoginMutation, useAdmin_loginMutation, useSendOtpMutation,useResetPasswordMutation,useRegisterMutation } =
  authApiSlice;
